import React from 'react';
import { gettext, ngettext } from '../../i18n';
import styles from './CollectionSummary.module.scss';

interface UpcomingEventsProps {
    numUpcomingEvents?: number;
    children?: React.ReactNode;
}

const UpcomingEvents: React.FunctionComponent<UpcomingEventsProps> = (
    props,
) => {
    if (
        props.numUpcomingEvents === null ||
        props.numUpcomingEvents === undefined
    ) {
        return null;
    }

    const { numUpcomingEvents } = props;

    return (
        <div
            className={styles.upcomingEvents}
            data-testid="collection-card--number-upcoming-events"
        >
            {props.numUpcomingEvents
                ? ngettext(
                      '%(numUpcomingEvents)s upcoming event',
                      '%(numUpcomingEvents)s upcoming events',
                      numUpcomingEvents,
                      { numUpcomingEvents },
                  )
                : gettext('No upcoming events')}
        </div>
    );
};

export const CollectionSummary: React.FunctionComponent<UpcomingEventsProps> = (
    props,
) => {
    if (
        !props.children &&
        (props.numUpcomingEvents === undefined ||
            props.numUpcomingEvents === null)
    ) {
        return null;
    }

    return (
        <div
            className={styles.summary}
            data-testid="collection-card--summary"
        >
            <UpcomingEvents numUpcomingEvents={props.numUpcomingEvents} />
            {props.children && (
                <div
                    className={styles.summaryClamp}
                    data-testid="collection-card--summary-children"
                >
                    {props.children}
                </div>
            )}
        </div>
    );
};
